import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, CreditCard, Zap } from 'lucide-react';
import { CART_LINK } from '../lib/constants';
export function Hero() {
  return <section className="relative w-full bg-white overflow-hidden pt-8 md:pt-12 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-125">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center" data-id="element-126">
        {/* Eyebrow + Headline (always at top) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col space-y-6 text-center lg:text-left order-1 lg:order-1" data-id="element-127">
          <div className="inline-block" data-id="element-128">
            <span className="bg-burgundy/10 text-burgundy text-xs md:text-sm font-bold tracking-wider uppercase py-1.5 px-3 rounded-full border border-burgundy/20" data-id="element-129">
              ⚠️ SI TU PREMENSTRUAL AFECTA TU ÁNIMO, PRODUCTIVIDAD Y CUERPO… ⚠️
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-dark leading-tight" data-id="element-130">
            Llegá a tu periodo con{' '}
            <span className="text-burgundy italic" data-id="element-131">menos dolor</span>,{' '}
            <span className="text-burgundy italic" data-id="element-132">menos hinchazón</span> y{' '}
            <span className="text-burgundy italic" data-id="element-133">menos cambios de humor</span>{' '}
            en solo 5 días, sin suplementos caros y sin dietas extremas
          </h1>
        </motion.div>

        {/* Hero Image — comes BEFORE the text-above-the-button */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative order-2 lg:order-2 lg:row-span-2" data-id="element-134">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-100 bg-white" data-id="element-135">
            <img src="https://cdn.magicpatterns.com/uploads/pjKerBEg7Z5k14E67yhcxb/ChatGPT_Image_21_may_2026,_07_20_12_p.m..png" alt="Kit 5x5 Ciclo en Calma — Guía, Recetas, Tracker, Meditación, IA y Ebook Periodo en Calma" className="w-full h-auto object-contain" data-id="element-136" />
          </div>
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-gold/20 rounded-full blur-2xl -z-10" data-id="element-137"></div>
          <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-burgundy/10 rounded-full blur-3xl -z-10" data-id="element-138"></div>
        </motion.div>

        {/* Subheadline + CTA + Trust — comes AFTER the image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col space-y-6 text-center lg:text-left order-3 lg:order-3" data-id="element-139">
          <h2 className="text-base sm:text-lg md:text-xl text-gray-700 font-sans max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-140">
            GUÍA 5x5 "Ciclo en Calma", tu plan simple para saber qué hacer
            durante los 5 días antes de que te venga para ganarle a los síntomas
            premenstruales.
          </h2>

          <div className="flex flex-col items-center lg:items-start space-y-4" data-id="element-141">
            <a href="#value-stack" className="w-full md:w-auto text-center bg-burgundy hover:bg-burgundy-dark text-white font-bold text-base md:text-lg lg:text-xl py-4 px-8 rounded-lg shadow-[0_4px_20px_rgba(107,15,26,0.4)] transition-all transform hover:scale-105 flex items-center justify-center" data-id="element-142">
              QUIERO MI KIT 5X5 CON 70% OFF
              <Zap className="ml-2 w-5 h-5" data-id="element-143" />
            </a>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-3 gap-y-2 text-xs sm:text-sm text-gray-600 font-medium" data-id="element-144">
              <span className="flex items-center" data-id="element-145">
                <ShieldCheck className="w-4 h-4 mr-1 text-burgundy" data-id="element-146" /> Pago
                seguro
              </span>
              <span data-id="element-147">·</span>
              <span className="flex items-center" data-id="element-148">
                <Zap className="w-4 h-4 mr-1 text-burgundy" data-id="element-149" /> Acceso inmediato
              </span>
              <span data-id="element-150">·</span>
              <span className="flex items-center" data-id="element-151">
                <CreditCard className="w-4 h-4 mr-1 text-burgundy" data-id="element-152" /> Mercado
                Pago / Tarjetas
              </span>
            </div>

            <div className="flex items-center space-x-2 pt-2" data-id="element-153">
              <div className="flex text-gold" data-id="element-154">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-155" />)}
              </div>
              <span className="text-sm font-semibold text-gray-800" data-id="element-156">
                +2.847 mujeres ya lo probaron
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}